"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require("reactackle-core");

var _TooltipStyled = require("./styles/TooltipStyled");

var _TooltipContentStyled = require("./styles/TooltipContentStyled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  isVisible: _propTypes2.default.bool,
  positionX: _propTypes2.default.oneOf(["right", "left"]),
  positionY: _propTypes2.default.oneOf(["top", "bottom"]),
  tooltipRef: _propTypes2.default.func
};
var defaultProps = {
  isVisible: true,
  positionX: "left",
  positionY: "bottom",
  tooltipRef: _reactackleCore.noop
};

var TooltipWrapper = function TooltipWrapper(_ref) {
  var isVisible = _ref.isVisible,
      positionX = _ref.positionX,
      positionY = _ref.positionY,
      tooltipRef = _ref.tooltipRef,
      children = _ref.children;
  return _react2.default.createElement(_TooltipStyled.TooltipStyled, {
    visible: isVisible,
    positionX: positionX,
    positionY: positionY,
    innerRef: tooltipRef
  }, _react2.default.createElement(_TooltipContentStyled.TooltipContentStyled, null, children));
};

TooltipWrapper.propTypes = propTypes;
TooltipWrapper.defaultProps = defaultProps;
exports.default = TooltipWrapper;